module.exports = __webpack_public_path__ + "img/main-border.2a68b4e9.png";